import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { can } from "@src/utils/components/permissions";

interface ModalConfirmProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ModalConfirm = (props: ModalConfirmProps) => {
  const { isOpen, onClose, onConfirm } = props;
  const canTransferBetweenTeams = can("credit_transfer_betweenTeams");

  const onConfirmWrapper = () => {
    onClose();
    onConfirm();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} trapFocus={false}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          <Trans>Transfer credit</Trans>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {canTransferBetweenTeams ? (
            <h3>
              {t`You are about to transfer credit to another team. Do you want to make transfer? `}
            </h3>
          ) : (
            <h3>
              {t`Credit transfer to another Team is not allowed for you, please contact financier to
            transfer credit.`}
            </h3>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="grey" onClick={onClose} variant="outline">
            {canTransferBetweenTeams ? t`No` : t`OK`}
          </Button>
          <Button
            ml={3}
            isDisabled={!canTransferBetweenTeams}
            onClick={onConfirmWrapper}
          >
            {canTransferBetweenTeams ? t`Yes` : t`Transfer credit`}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
